/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/
import { HelpPopup } from "../../components/helpPopup/helpPopup";
import { MessageText } from "../../constants/messageText";
import { CircularProgress } from "@mui/material";
import "./guestSignUp.scss";
import instance from "../../utils/axiosInstance";
import React, { useEffect } from "react";
import { ErrorCodes } from "../../constants/messageCodes";
import { SnackBarMessage } from "../../components/snackBar/snackBar";
import { SignUpSucees } from "../../components/signUpSucees/signUpSucees";
import { GuestDesktopLogin } from "../../constants/api-urlConstants";
import { isMobile } from 'react-device-detect';
import { docSearchBasePath } from "../../constants/env-url";

export const SignUpForTrialDesktop: React.FC<any> = () => {

  const [APIMsgConfig, setAPIMsgConfig] = React.useState({
    type: "",
    message: "",
    snackFlag: false,
  });
  const [statusIsLoading, setStatusIsLoading] = React.useState(false);

  const createGuestUserDesktop = () => {
    setStatusIsLoading(false);
    const userCreatedBy = window.location.search;
    const payload: any = {
      key: userCreatedBy.slice(1),
      mobile: isMobile
    };

    const USER_API_BASE_URL = `${GuestDesktopLogin}`;
    instance
      .post(USER_API_BASE_URL, payload)
      .then((response) => {
        const res = response.data;
        if (res.success) {
          window.open(docSearchBasePath, '_self');
        }
        else {
          if (res.message_code === ErrorCodes.INVALID_DEVICE) {
            setStatusIsLoading(true);
            setAPIMsgConfig({
              type: 'error',
              message: MessageText.INVALID_DEVICE_Text,
              snackFlag: true
            })
          } else if (res.message_code === ErrorCodes.INVALID_GUEST_URL) {
            setStatusIsLoading(true);
            setAPIMsgConfig({
              type: 'error',
              message: MessageText.INVALID_GUEST_URL_Text,
              snackFlag: true
            })
          } else if (res.message_code === ErrorCodes.INVALID_GUEST_QR) {
            setAPIMsgConfig({
              type: 'error',
              message: MessageText.INVALID_GUEST_QR_Text,
              snackFlag: true
            })
          } else if (res.message_code === ErrorCodes.DUPLICATE_USERNAME) {
            setStatusIsLoading(true);
          }
          else {
            setStatusIsLoading(true);
            setAPIMsgConfig({
              type: 'error',
              message: MessageText.WENT_WRONG,
              snackFlag: true
            })
          }
        }
      })
      .catch((error) => {
        setAPIMsgConfig({
          type: 'error',
          message: MessageText.WENT_WRONG,
          snackFlag: true
        })

      });
  };

  useEffect(() => {
    if (!isMobile) {
      createGuestUserDesktop()
    }
  }, [])

  return (
    <>
      <div className="guest-signUp-wrapper flex-direction-column">
        <div className="pageHeader vertical-align">
          <img
            style={{ width: "220px", paddingLeft: "10px" }}
            alt=""
            src={require("../../assets/images/infraclearlogo.png")}
          />
          <HelpPopup />
        </div>
        <div className="authWrapper">
          <div className="login-wrapper ">
            {!isMobile ? (
              <>
                {statusIsLoading ?
                  <SignUpSucees
                    showText={MessageText.CLICK_SECOND_TIME_SAME_URL}
                    popupName={"desktop_second_time"}
                    popupDevice={isMobile}
                  />
                  :
                  <CircularProgress />
                }
              </>
            ) : (
              <>
                <SignUpSucees
                  showText={isMobile ? MessageText.MOBILE_Desktop_GUEST_SIGNUP_MSG_DESC : MessageText.GUEST_SIGNUP_MSG_DESC}
                  popupName={"signUpTrialDesktop"}
                  popupDevice={isMobile}
                />
              </>
            )}
          </div>
        </div>
      </div>
      {APIMsgConfig.snackFlag && (
        <div>
          <SnackBarMessage snacBarValue={APIMsgConfig} />
        </div>
      )}
    </>
  );
};
